import React, { useRef, useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import LinearProgress from "@mui/material/LinearProgress";
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import axios from "axios";
import CreateEditAccount from "../salesman/CreateEditSalesman";
import DeleteIcon from "@mui/icons-material/Delete";
import SellIcon from "@mui/icons-material/Sell";
import Autocomplete from "@mui/material/Autocomplete";

import Principals from "../principals/Principals";

const drawerWidth = 300;

const materialTheme = createTheme({
  // set default for now
});

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  appBar: {
    position: "fixed",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  fullWidth: {
    width: "100%",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CreateEditProduct(props) {
  const classes = useStyles();

  const [isSavingProduct, setIsSavingProduct] = useState(false);
  const [showMessageDialog, setShowMessageDialog] = useState(false);
  const [isSavingSuccess, setIsSavingSuccess] = useState(false);
  const [messageDialogMessage, setMessageDialogMessage] = useState("");
  const [productFieldSettings, setProductFieldSettings] = useState([]);
  const [showPrincipalDialog, setShowPrincipalDialog] = useState(false);
  const [principals, setPrincipals] = useState([]);
  const [searchCategoryTerm, setSearchCategoryTerm] = useState({ name: "" });
  const [autoCompleteSearchOptionMessage, setAutoCompleteSearchOptionMessage] =
    useState("Searching...");
  const [autoSuggestProductCategories, setAutoSuggestProductCategories] = useState([]);
  const [loadCategories, setLoadCategories] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [productCategories, setProductCategories] = useState([]);

  //Nestle Products Only
  const principal = "nestle";
  const [product, setProducts] = useState({
    code: "",
    name: "",
    short_name: "",
    product_common_name: "",
    description: "",
    barcode: "",
    principal: "",
    brand: "",
    category: "",
    variant: "",
    size: "",
  });

  const [uoms, setUoms] = useState([
    { uom: "", converted_to_smallest_value: "", price_with_tax: "", price_without_tax: "" },
  ]);

  const handleAddUoms = () => {
    const newUoms = {
      uom: "",
      converted_to_smallest_value: "",
      price_with_tax: "",
      price_without_tax: "",
    };
    setUoms([...uoms, newUoms]);
  };

  const uomInputListener = (index, fieldKey, value) => {
    const updatedUoms = [...uoms];
    updatedUoms[index][fieldKey] = value;
    setUoms(updatedUoms);
  };

  const handleClickRemoveUOM = (indexToRemove) => {
    const updatedUoms = uoms.filter((uom, index) => index !== indexToRemove);
    setUoms(updatedUoms);
  };

  const inputOnChangeListener = (event) => {
    const modifiedProduct = { ...product };

    modifiedProduct[event.target.name] = event.target.value;
    setProducts(modifiedProduct);
  };

  const handleInputKeyPress = (event) => {
    if (!/^[0-9.]*$/.test(event.key)) {
      event.preventDefault();
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();

    const pastedText = event.clipboardData.getData("text/plain");
    const sanitizedText = pastedText.replace(/[^\d]/g, ""); // Remove non-numeric characters
    document.execCommand("insertText", false, sanitizedText);
  };

  useEffect(() => {
    if (props.selectedProducts === null || props.selectedProducts === undefined) {
      return;
    }

    const editProduct = { ...product };
    editProduct.code = props.selectedProducts.code;
    editProduct.name = props.selectedProducts.name;
    editProduct.short_name = props.selectedProducts.short_name;
    editProduct.product_common_name = props.selectedProducts.product_common_name;
    editProduct.description = props.selectedProducts.description;
    editProduct.barcode = props.selectedProducts.barcode;
    editProduct.principal = props.selectedProducts.principal;
    editProduct.brand = props.selectedProducts.brand;
    editProduct.category = props.selectedProducts.category;
    editProduct.variant = props.selectedProducts.variant;
    editProduct.size = props.selectedProducts.size;
    setSearchCategoryTerm({ name: props.selectedProducts.category });
    setProducts(editProduct);
    setUoms(props.selectedProducts.Units);
  }, [props.productAction]);

  const progressDialog = () => {
    return (
      <Dialog fullWidth={true} maxWidth={"lg"} open={isSavingProduct} onClose={() => {}}>
        <DialogContent>
          <DialogContentText>Saving product... Please wait...</DialogContentText>
          <LinearProgress color="secondary" />
        </DialogContent>
      </Dialog>
    );
  };

  const messageDialog = () => {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={showMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {messageDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowMessageDialog(false);

              if (isSavingSuccess) {
                props.setProductAction("add");
                props.setSelectedProducts(null);
                props.setOpenCreateEditProduct(false);
                props.setLoadProducts(true);
                props.setPageNumber(1);
                props.setProductsTable([]);
              }
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const uomList = () => {
    let is_disabled_removed = false;
    if (uoms.length === 1) {
      is_disabled_removed = true;
    }

    return (
      <>
        {uoms.map((field, index) => (
          <React.Fragment key={index}>
            <Grid item xs={3}>
              <Grid item xs={12}>
                Unit*
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        autoComplete="off"
                        type="text"
                        className={classes.fullWidth}
                        value={field.uom}
                        rows={4}
                        variant="outlined"
                        onChange={(e) => uomInputListener(index, "uom", e.target.value)}
                        disabled={
                          props.productAction !== "add" &&
                          (product.principal?.toLowerCase() || "").includes(principal)
                        }
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>
            </Grid>

            <Grid item xs={9}>
              <Grid item xs={12}>
                Converted to smallest value*
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        autoComplete="off"
                        type="text"
                        className={classes.fullWidth}
                        value={field.converted_to_smallest_value}
                        rows={4}
                        variant="outlined"
                        onChange={(e) =>
                          uomInputListener(index, "converted_to_smallest_value", e.target.value)
                        }
                        onKeyPress={handleInputKeyPress} // Handle key press to restrict input
                        onPaste={handlePaste}
                        disabled={
                          props.productAction !== "add" &&
                          (product.principal?.toLowerCase() || "").includes(principal)
                        }
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                Price with Tax*
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        autoComplete="off"
                        type="text"
                        className={classes.fullWidth}
                        value={field.price_with_tax}
                        name="price_with_tax"
                        id="price_with_tax"
                        rows={4}
                        variant="outlined"
                        onChange={(e) => uomInputListener(index, "price_with_tax", e.target.value)}
                        onKeyPress={handleInputKeyPress} // Handle key press to restrict input
                        onPaste={handlePaste}
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                Price without tax*
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        autoComplete="off"
                        type="text"
                        className={classes.fullWidth}
                        value={field.price_without_tax}
                        name="price_without_tax"
                        id="price_without_tax"
                        rows={4}
                        variant="outlined"
                        onChange={(e) =>
                          uomInputListener(index, "price_without_tax", e.target.value)
                        }
                        onKeyPress={handleInputKeyPress} // Handle key press to restrict input
                        onPaste={handlePaste}
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>
            </Grid>

            {!(product.principal?.toLowerCase() || "").includes(principal) && (
              <Grid item container>
                <Button
                  disabled={is_disabled_removed}
                  variant="contained"
                  color="error"
                  style={{ width: "100%" }}
                  onClick={(e) => handleClickRemoveUOM(index)}
                >
                  <DeleteIcon className={classes.extendedIcon} /> Remove UOM
                </Button>
              </Grid>
            )}
          </React.Fragment>
        ))}
      </>
    );
  };

  useEffect(() => {
    getProductFieldSettings();
    getPrincipals();
  }, []);

  const getProductFieldSettings = () => {
    const options = {
      method: "POST",
      url: "/TransactiLiteGeneralSettings/getProductFieldSettings.json",
      data: objectToFormData({
        function_name: "transacti_lite_product_fields",
      }),
    };

    axios(options)
      .then((response) => {
        const is_success = response.data.response.is_success;
        const settings = response.data.response.settings;

        setProductFieldSettings(settings);
      })
      .catch((error) => {
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage(error.message);
        setShowMessageDialog(true);
      });
  };

  const getPrincipals = () => {
    const options = {
      method: "POST",
      url: "/TransactiProductCategories/getTransactiLitePrincipal.json",
      data: {},
    };

    axios(options)
      .then((response) => {
        const is_success = response.data.response.is_success;
        const principals = response.data.response.principals;

        if (!is_success) {
          setMessageDialogMessage(response.data.response.message);
          setShowMessageDialog(true);
        }

        setPrincipals(principals);
      })
      .catch((error) => {
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage(error.message);
        setShowMessageDialog(true);
      });
  };

  const saveProduct = () => {
    setIsSavingProduct(true);
    const newProduct = { ...product, unit: uoms, category: searchCategoryTerm.name };

    const validate_product = validateProducts(newProduct);

    if (!validate_product) {
      return;
    }

    const options = {
      method: "POST",
      url: "/TransactiSellerProducts/saveProduct.json",
      data: objectToFormData({
        product: JSON.stringify(product),
        uom: JSON.stringify(uoms),
        product_required_fields: JSON.stringify(productFieldSettings),
      }),
    };

    axios(options)
      .then((response) => {
        let err_msg = "";
        const is_success = response.data.response.is_success;
        const errors = response.data.response.errors || [];

        if (errors.length > 0) {
          errors.map((data, key) => {
            err_msg += data + "\n";
          });

          setMessageDialogMessage(err_msg);
          setShowMessageDialog(true);
        } else {
          setMessageDialogMessage(response.data.response.message);
          setShowMessageDialog(true);
        }

        setIsSavingSuccess(is_success);
        setIsSavingProduct(false);
      })
      .catch((error) => {
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage(error.message);
        setShowMessageDialog(true);
      });
  };

  const validateProducts = (newProduct) => {
    let is_valid = true;

    if (product.code.length === 0) {
      setIsSavingSuccess(false);
      setIsSavingProduct(false);
      setMessageDialogMessage("Product Code is required");
      setShowMessageDialog(true);
      is_valid = false;
      return is_valid;
    }

    if (product.name.length === 0) {
      setIsSavingSuccess(false);
      setIsSavingProduct(false);
      setMessageDialogMessage("Product Name is required");
      setShowMessageDialog(true);
      is_valid = false;
      return is_valid;
    }

    productFieldSettings.forEach((value, index) => {
      if (value === "short_name" && product.short_name.length === 0) {
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage("Product Short Name is required");
        setShowMessageDialog(true);
        is_valid = false;
        return is_valid;
      }

      if (value === "common_name" && product.product_common_name.length === 0) {
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage("Product Common Name is required");
        setShowMessageDialog(true);
        is_valid = false;
        return is_valid;
      }

      if (value === "description" && product.description.length === 0) {
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage("Product Description is required");
        setShowMessageDialog(true);
        is_valid = false;
        return is_valid;
      }

      if (value === "barcode" && product.barcode.length === 0) {
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage("Product Barcode is required");
        setShowMessageDialog(true);
        is_valid = false;
        return is_valid;
      }

      if (value === "principal" && product.principal.length === 0) {
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage("Product Principal is required");
        setShowMessageDialog(true);
        is_valid = false;
        return is_valid;
      }

      if (value === "brand" && product.brand.length === 0) {
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage("Product Brand is required");
        setShowMessageDialog(true);
        is_valid = false;
        return is_valid;
      }

      if (value === "category" && product.category.length === 0) {
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage("Product Category is required");
        setShowMessageDialog(true);
        is_valid = false;
        return is_valid;
      }

      if (value === "size" && product.size.length === 0) {
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage("Product Size is required");
        setShowMessageDialog(true);
        is_valid = false;
        return is_valid;
      }

      if (value === "variant" && product.variant.length === 0) {
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage("Product Variant is required");
        setShowMessageDialog(true);
        is_valid = false;
        return is_valid;
      }
    });

    newProduct.unit.forEach((value, index) => {
      if (value.uom.length === 0) {
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage("Product Uom is required");
        setShowMessageDialog(true);
        is_valid = false;
        return is_valid;
      }

      if (value.converted_to_smallest_value.length === 0) {
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage("Converted to smallest value cannot be empty");
        setShowMessageDialog(true);
        is_valid = false;
        return is_valid;
      }

      if (value.price_with_tax.length === 0) {
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage("Price with tax cannot be empty");
        setShowMessageDialog(true);
        is_valid = false;
        return is_valid;
      }

      if (value.price_without_tax.length === 0) {
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage("Price without tax cannot be empty");
        setShowMessageDialog(true);
        is_valid = false;
        return is_valid;
      }
    });

    return is_valid;
  };

  const updateProduct = () => {
    setIsSavingProduct(true);
    const newProduct = { ...product, unit: uoms, category: searchCategoryTerm.name };
    const validate_product = validateProducts(newProduct);

    if (!validate_product) {
      return;
    }

    const options = {
      method: "POST",
      url: "/TransactiSellerProducts/updateProduct.json",
      data: objectToFormData({
        id: props.selectedProducts.seller_id,
        product: JSON.stringify(product),
        uom: JSON.stringify(uoms),
        product_required_fields: JSON.stringify(productFieldSettings),
      }),
    };

    axios(options)
      .then((response) => {
        let err_msg = "";
        const is_success = response.data.response.is_success;
        const errors = response.data.response.errors || [];

        if (errors.length > 0) {
          errors.map((data, key) => {
            err_msg += data + "\n";
          });

          setMessageDialogMessage(err_msg);
          setShowMessageDialog(true);
        } else {
          setMessageDialogMessage(response.data.response.message);
          setShowMessageDialog(true);
        }

        setIsSavingSuccess(is_success);
        setIsSavingProduct(false);
      })
      .catch((error) => {
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage(error.message);
        setShowMessageDialog(true);
      });
  };

  const objectToFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);

      return formData;
    }, new FormData());

  const handleshowPrincipal = () => {
    setShowPrincipalDialog(true);
  };

  useEffect(() => {
    function fetchAutoSuggestProducts(searchString) {
      const loadCategories = async () => {
        setAutoCompleteSearchOptionMessage("Searching");

        const options = {
          method: "POST",
          url: "/TransactiSellerProducts/getProductCategoriesForAutoSuggest.json",
          data: objectToFormData({ search_term: searchString }),
        };
        await axios(options).then((res) => {
          const categories = res.data.categories;
          if (categories.length <= 0) {
            setAutoCompleteSearchOptionMessage("No record found.");
            setAutoSuggestProductCategories([]);
          } else {
            setAutoSuggestProductCategories(categories);
          }
        });
      };
      loadCategories();
    }

    if (searchCategoryTerm == null) {
      fetchAutoSuggestProducts("");
    } else {
      fetchAutoSuggestProducts(searchCategoryTerm.name);
    }
  }, [searchCategoryTerm]);

  function autoComplete() {
    return (
      <Autocomplete
        value={searchCategoryTerm}
        noOptionsText={autoCompleteSearchOptionMessage}
        disabled={
          props.productAction !== "add" &&
          (product.principal?.toLowerCase() || "").includes(principal)
        }
        onChange={(event, newValue) => {
          if (newValue == null || newValue.name === "") {
            searchCategoryTerm.name = "";
            const modified = { ...product };
            modified.category = "notInList";
            setProducts(modified);
            return;
          }

          searchCategoryTerm.name = newValue.name;
          setProductCategories([]);
          setPageNumber(1);
          setLoadCategories(true);

          const modified = { ...product };
          modified.category = searchCategoryTerm.name;
          setProducts(modified);
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        options={autoSuggestProductCategories}
        isOptionEqualToValue={(option, value) => true}
        getOptionLabel={(option) => {
          return option.name;
        }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.name}>
              {option.name}
            </li>
          );
        }}
        style={{ width: "100%", paddingLeft: "8px" }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            id="category"
            rows={4}
            InputProps={{ ...params.InputProps }}
            onChange={(event) => {
              setSearchCategoryTerm({ name: event.target.value });
              const modified = { ...product };
              modified.category = event.target.value;
              setProducts(modified);
            }}
          />
        )}
      />
    );
  }

  return (
    <div>
      <Dialog
        fullScreen
        open={props.openCreateEditProduct}
        onClose={() => {
          props.setProductAction("add");
        }}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => {
                props.setProductAction("add");
                props.setSelectedProducts(null);
                props.setOpenCreateEditProduct(false);
              }}
              aria-label="close"
              size="large"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="subtitle1" className={classes.title}>
              {props.productAction == "add" ? "Add Product" : "Update Product"}
            </Typography>
          </Toolbar>
        </AppBar>
        <div className={classes.appBarSpacer}></div>
        <div style={{ padding: ".5rem" }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Grid item xs={12}>
                Product Code*
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        autoComplete="off"
                        type="text"
                        className={classes.fullWidth}
                        value={product.code}
                        name="code"
                        id="code"
                        rows={4}
                        variant="outlined"
                        onChange={inputOnChangeListener}
                        disabled={props.productAction == "add" ? false : true}
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                Product Name*
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        autoComplete="off"
                        type="text"
                        className={classes.fullWidth}
                        value={product.name}
                        name="name"
                        id="name"
                        rows={4}
                        variant="outlined"
                        onChange={inputOnChangeListener}
                        disabled={
                          props.productAction !== "add" &&
                          (product.principal?.toLowerCase() || "").includes(principal)
                        }
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                Short Name{productFieldSettings.includes("short_name") ? "*" : ""}
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        autoComplete="off"
                        type="text"
                        className={classes.fullWidth}
                        value={product.short_name}
                        name="short_name"
                        id="short_name"
                        rows={4}
                        variant="outlined"
                        onChange={inputOnChangeListener}
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                Common Name{productFieldSettings.includes("common_name") ? "*" : ""}
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        autoComplete="off"
                        type="text"
                        className={classes.fullWidth}
                        value={product.product_common_name}
                        name="product_common_name"
                        id="product_common_name"
                        rows={4}
                        variant="outlined"
                        onChange={inputOnChangeListener}
                        disabled={
                          props.productAction !== "add" &&
                          (product.principal?.toLowerCase() || "").includes(principal)
                        }
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid item xs={12}>
                Description{productFieldSettings.includes("description") ? "*" : ""}
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        autoComplete="off"
                        type="text"
                        className={classes.fullWidth}
                        value={product.description}
                        name="description"
                        id="description"
                        rows={4}
                        variant="outlined"
                        onChange={inputOnChangeListener}
                        disabled={
                          props.productAction !== "add" &&
                          (product.principal?.toLowerCase() || "").includes(principal)
                        }
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                Barcode{productFieldSettings.includes("barcode") ? "*" : ""}
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        autoComplete="off"
                        type="text"
                        className={classes.fullWidth}
                        value={product.barcode}
                        name="barcode"
                        id="barcode"
                        rows={4}
                        variant="outlined"
                        onChange={inputOnChangeListener}
                        disabled={
                          props.productAction !== "add" &&
                          (product.principal?.toLowerCase() || "").includes(principal)
                        }
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid item xs={12}>
                Principal{productFieldSettings.includes("principal") ? "*" : ""}
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        autoComplete="off"
                        type="text"
                        className={classes.fullWidth}
                        value={product.principal}
                        name="principal"
                        id="principal"
                        rows={4}
                        variant="outlined"
                        onClick={handleshowPrincipal}
                        disabled={
                          props.productAction !== "add" &&
                          (product.principal?.toLowerCase() || "").includes(principal)
                        }
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>
            </Grid>

            <Grid item xs={4}>
              <Grid item xs={12}>
                Brand{productFieldSettings.includes("brand") ? "*" : ""}
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        autoComplete="off"
                        type="text"
                        className={classes.fullWidth}
                        value={product.brand}
                        name="brand"
                        id="brand"
                        rows={4}
                        variant="outlined"
                        onChange={inputOnChangeListener}
                        disabled={
                          props.productAction !== "add" &&
                          (product.principal?.toLowerCase() || "").includes(principal)
                        }
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>
            </Grid>

            <Grid item xs={4}>
              <Grid item xs={12}>
                Category{productFieldSettings.includes("category") ? "*" : ""}
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>{autoComplete()}</form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>
            </Grid>

            <Grid item xs={4}>
              <Grid item xs={12}>
                size{productFieldSettings.includes("size") ? "*" : ""}
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        autoComplete="off"
                        type="text"
                        className={classes.fullWidth}
                        value={product.size}
                        name="size"
                        id="size"
                        rows={4}
                        variant="outlined"
                        onChange={inputOnChangeListener}
                        disabled={
                          props.productAction !== "add" &&
                          (product.principal?.toLowerCase() || "").includes(principal)
                        }
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid item xs={12}>
                Variant{productFieldSettings.includes("variant") ? "*" : ""}
              </Grid>
              <Grid item xs={12}>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <form noValidate>
                      <TextField
                        autoComplete="off"
                        type="text"
                        className={classes.fullWidth}
                        value={product.variant}
                        name="variant"
                        id="variant"
                        rows={4}
                        variant="outlined"
                        onChange={inputOnChangeListener}
                        disabled={
                          props.productAction !== "add" &&
                          (product.principal?.toLowerCase() || "").includes(principal)
                        }
                      />
                    </form>
                  </ThemeProvider>
                </StyledEngineProvider>
              </Grid>
            </Grid>

            <Grid item container>
              <Grid item xs={4}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAddUoms}
                  disabled={
                    props.productAction !== "add" &&
                    (product.principal?.toLowerCase() || "").includes(principal)
                  }
                >
                  <SellIcon /> Add UOM
                </Button>
              </Grid>
            </Grid>

            {uomList()}

            <Grid item container>
              <Button
                variant="contained"
                color="primary"
                style={{ width: "100%" }}
                onClick={props.productAction == "add" ? saveProduct : updateProduct}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </div>
      </Dialog>

      {showPrincipalDialog ? (
        <Principals
          showPrincipalDialog={showPrincipalDialog}
          setShowPrincipalDialog={setShowPrincipalDialog}
          principals={principals}
          setProducts={setProducts}
          product={product}
        />
      ) : (
        ""
      )}

      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
          {progressDialog()}
          {messageDialog()}
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
}

export default CreateEditProduct;
